module.exports = __webpack_public_path__ + "img/facebook.e0381dec.svg";